module.exports = __webpack_public_path__ + "static/media/Lora-Italic.d36745bb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Lora-Italic.ttf
// module id = 3262
// module chunks = 70